import React from 'react'
import PropTypes from 'prop-types'
import useGlobalLoading from '@/hooks/useGlobalLoading'
import ContentForDesktop from './components/ContentForDesktop'
import ContentForMobile from './components/ContentForMobile'
import { getHeroData } from './functions'
import { useMediaQuery } from '@uidotdev/usehooks'

Hero.propTypes = {
  data: PropTypes.object,
}

export default function Hero({ data }) {
  const isMobile = useMediaQuery('only screen and (max-width: 768px)')
  const isTablet = useMediaQuery('only screen and (min-width : 768px) and (max-width : 1280px)')
  const isDesktop = useMediaQuery('only screen and (min-width: 1280px)')

  const { loading } = useGlobalLoading()

  const { containerStyles, backgroundStyle } = getHeroData({
    data,
    isMobile,
    isTablet,
    isDesktop,
  })

  return (
    <section className={containerStyles} style={backgroundStyle}>
      {isDesktop ? (
        <ContentForDesktop data={data?.rows} loading={loading} />
      ) : (
        <ContentForMobile data={data?.rows} loading={loading} />
      )}
    </section>
  )
}
